import PropTypes from 'prop-types';

import {
  Tooltip as ShadcnTooltip,
  TooltipContent as ShadcnTooltipContent,
  TooltipProvider as ShadcnTooltipProvider,
  TooltipTrigger as ShadcnTooltipTrigger,
} from '#/modules/commonComponents/shadcn/ui/tooltip';

/** 全站預設：滑過約 0.5s 才顯示，避免快速掠過即顯 */
export const DEFAULT_TOOLTIP_DELAY_MS = 500;

const TooltipProvider = ({
  delayDuration = DEFAULT_TOOLTIP_DELAY_MS,
  ...props
}) => (
  <ShadcnTooltipProvider delayDuration={delayDuration} {...props} />
);

TooltipProvider.propTypes = {
  delayDuration: PropTypes.number,
  children: PropTypes.node,
};

export {
  ShadcnTooltip as Tooltip,
  ShadcnTooltipTrigger as TooltipTrigger,
  ShadcnTooltipContent as TooltipContent,
  TooltipProvider,
};
